import React from "react";

import { CloseRounded, SendRounded } from "@mui/icons-material";
import { Box, DialogContent, TextField } from "@mui/material";

import useAuth from "../../config/context/authContext";
import useModal from "../../config/context/modalContext";
import { ReportService } from "../../config/services/ReportService";
import { GreyPallet } from "../../config/styles";
import { Dev } from "../../config/util/consoleUtil";

import { WideDialog } from "../MainModalSimple/styles";
import MainSolidButton from "../MainSolidButton";
import MainText from "../MainText";
import { ModalTransition } from "../ModalTransition";
import PageHeader from "../PageHeader";

import { ModalBaseType } from "../../types/common";
import { ReportType } from "../../types/database";

type ModalReportType = ModalBaseType & {
  reportInfo: {
    postId?: string;
    commentId?: string;
  };
};

export default function ModalReportCreate({ reportInfo, onClose }: ModalReportType) {
  const [open, setOpen] = React.useState(true);

  const ReportCreate = ReportService.Create();

  const { pushAlert } = useModal();

  const { currentUserState } = useAuth();

  const [postField, setPostField] = React.useState("");

  const handleSend = async () => {
    try {
      const dateNow = new Date();

      const sendItem = {
        createdAtTimestamp: dateNow.getTime(),
        createdAtISO: dateNow.toISOString(),
        userId: currentUserState?.uid,
        text: postField,
        status: "pending",
        reportInfo,
      } as ReportType;

      await ReportCreate.runRequest(sendItem);

      pushAlert({
        type: "success",
        message: "Sua denúncia foi enviada para avaliação",
      });

      handleClose();
    } catch (error) {
      console.log(...new Dev("handleSend", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao criar denúncia",
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={"Denunciar " + (reportInfo?.commentId ? "Comentário" : "Postagem")}
          rightIcon={<CloseRounded />}
          onRightAction={handleClose}
        />

        <Box>
          <Box mt={4}>
            <TextField
              autoCapitalize="sentences"
              fullWidth
              multiline
              rows={4}
              label="Denúncia"
              variant="outlined"
              sx={{
                "& .MuiFormLabel-root": {
                  fontWeight: "bold",
                  color: `${GreyPallet.Regular} !important`,
                },

                "& .MuiOutlinedInput-root": {
                  borderRadius: "15px",
                },

                "& .MuiInputBase-input": {
                  fontWeight: "bold",
                  fontSize: 16,
                  color: GreyPallet.Regular,
                },

                "& .MuiSvgIcon-root": {
                  fontSize: 26,
                },

                "& .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "3px !important",
                  borderColor: `${GreyPallet.Regular} !important`,
                  borderStyle: "solid",
                  "& .Mui-focused": {
                    borderColor: `${GreyPallet.Regular} !important`,
                  },
                },
              }}
              value={postField}
              onChange={(e) => setPostField(e.target.value)}
            />
          </Box>

          <Box my={3}>
            <MainSolidButton
              loading={ReportCreate.isLoading}
              text="Enviar"
              color="danger"
              icon={<SendRounded />}
              onClick={handleSend}
            />
          </Box>

          <MainText size="caption" color="regular">
            A sua denúncia será avaliada por um moderador
          </MainText>
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
